import { theme } from './theme'
import loadDependencies from './load-dependencies'

export { loadDependencies, theme }